
import { useState, useEffect } from 'react';
import { Button, Row, Col, Form} from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { addLocation } from '../../services/Configs/LocationsService'
 

function AddLocationModal({ show, handleClose, handleReload }) {
  const [locationName, setLocationName] = useState("");
  
  const handleChangeLocationName = (e) => {
        const { value } = e.target;
        setLocationName(value);
  }
  const handleAddLocation = () => {
    let pendingInputs = [];
    if(!locationName)
    {
        pendingInputs.push("Ubicación")
    }
    if(pendingInputs.length == 0)
    {

        addLocation(locationName).then(locationResult => {
        toast.success('ubicación creada correctamente');
        handleClose();
        handleReload();
        });
    }
    else
    {
        toast.warning(`Lo sentimos, debes completar los siguientes campos: ${pendingInputs.join(', ')}`)
    }
  }
  useEffect(() => {
    if (show) {
      setLocationName("");
    }
  }, [show]);
  return (
    <Modal size="sm" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Agregar ubicación</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
              <Col xl={12} className=' p-2'  >
                <Form.Label>Nombre:</Form.Label>
                          <Form.Group controlId="">
                          <Form.Control
                              type="text"
                              name="name"
                              placeholder='Nombre de la ubicación'
                              value={locationName}
                              onChange={handleChangeLocationName}
                          />
                  </Form.Group>
              </Col>
       </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleAddLocation}>
           Guardar ubicación
        </Button>
        <Button variant="secondary" onClick={handleClose}>
           Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddLocationModal;
